import { useEffect, type RefObject } from 'react'

const tabbableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

export const useFocusTrap = (isActive: boolean, containerRef: RefObject<HTMLElement | null>) => {
  useEffect(() => {
    if (!isActive) return undefined
    const previouslyFocused = document.activeElement instanceof HTMLElement ? document.activeElement : null
    const focusFirst = () => (containerRef.current?.querySelectorAll<HTMLElement>(tabbableSelector)[0] ?? containerRef.current)?.focus()
    const frame = window.requestAnimationFrame(focusFirst)
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Tab' || !containerRef.current) return
      const tabbables = Array.from(containerRef.current.querySelectorAll<HTMLElement>(tabbableSelector))
      if (!tabbables.length) { event.preventDefault(); return }
      const current = document.activeElement
      const first = tabbables[0]
      const last = tabbables[tabbables.length - 1]
      if (event.shiftKey && (current === first || !containerRef.current.contains(current))) { event.preventDefault(); last.focus() }
      else if (!event.shiftKey && (current === last || !containerRef.current.contains(current))) { event.preventDefault(); first.focus() }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => { window.cancelAnimationFrame(frame); document.removeEventListener('keydown', onKeyDown); previouslyFocused?.focus() }
  }, [containerRef, isActive])
}
